"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isSectionEmpty;
var _lodash = require("lodash");
function isSectionEmpty() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hiddenFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var questionIds = (0, _lodash.map)(section.questions, 'id');
  var diff = (0, _lodash.difference)(questionIds, hiddenFields);
  return (0, _lodash.isEmpty)(diff);
}